import React from 'react';
import { Link } from 'react-router-dom';

const Header = () => {
    return (
        <header className="flex min-h-[80px] items-center justify-between border-b border-[#353535] bg-[#050505] px-[7.5%] max-[640px]:min-h-0 max-[640px]:flex-col max-[640px]:items-start max-[640px]:gap-6 max-[640px]:px-[6%] max-[640px]:py-6">
            <Link className="whitespace-nowrap text-[clamp(1.7rem,2.2vw,2.25rem)] font-normal leading-none tracking-[0.28em] text-[#f5f5f5] no-underline" to="/" aria-label="TakeMe2Space home">
                BHU<span className="text-[#e74b0b]">W</span>AIVS
            </Link>
            <nav className="flex items-center gap-[clamp(1.1rem,2vw,2rem)] max-[640px]:flex-wrap max-[640px]:gap-x-5 max-[640px]:gap-y-4" aria-label="Main navigation">
                <Link className="text-[0.85rem] font-normal text-[#f5f5f5] no-underline transition-colors duration-150 hover:text-[#e74b0b] focus-visible:text-[#e74b0b]" to="/">Home</Link>
                <Link className="text-[0.85rem] font-normal text-[#f5f5f5] no-underline transition-colors duration-150 hover:text-[#e74b0b] focus-visible:text-[#e74b0b]" to="/about">About</Link>
                <Link className="text-[0.85rem] font-normal text-[#f5f5f5] no-underline transition-colors duration-150 hover:text-[#e74b0b] focus-visible:text-[#e74b0b]" to="/admin">Admin</Link>
            </nav>
        </header>
    );
};

export default Header;
